import { HisRule, SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class HisRowParser_環境監測 {


  static ConvertToHisRow(func_guid: string, step: SpwkHisStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): HisRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_環境監測) {
      throw new Error("6849132 必須是 CHAPTER_環境監測 !!!");
    }

    const re: HisRow[] = [];

    if (NotNeed環境監測(func_guid) === true) {
      return re;// 不需要環境監測的問卷
    }

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_環境監測);

    for (const q_meta of q_meta_list) {
      if (q_meta.q_his_rule === HisRule.None) {
        // pass; do nothing...

      } else if (q_meta.q_his_rule === HisRule.CH7) {
        const data_row: HisRow = new HisRow(基本檔, step.HIS類別代碼);
        data_row.項目 = q_meta.his_code;
        let find = meta_table.GetRadioOption_HisCodeBundle(q_meta);
        data_row.結果 = find.his_code;
        re.push(data_row);

        /* 特殊規則，有勾 登錄系統 時，補上 "事業單位編號" FIXME: 改乾淨一點 */
        if (q_meta.code === "登錄系統" && data_row.結果 === "10") {

          let meta = meta_table.FindQuestionMeta_ByChapterAndCode(SpwkUtilV3.CHAPTER_環境監測, "事業單位編號");
          if (meta == null) {
            throw new_ErrorAlert("預期要有 Q事業單位編號 !!!");
          }

          let q_guid = meta.question_guid;

          let inputs = meta_table.FilterInputs_ByChapter(SpwkUtilV3.CHAPTER_環境監測);
          let q_inputs = inputs.filter(x => x.question_guid === q_guid);

          if (q_inputs.length !== 1 || q_inputs[0].code !== "1") {
            throw new_ErrorAlert("預期要有 事業單位編號 Input !!!");
          }

          data_row.備註 = q_inputs[0].rhf_value ?? "";// 事業單位編號

        }


      } else {
        throw new_ErrorAlert("46431 環境監測: 未知的 q_his_rule: " + q_meta.q_his_rule + " !!!\ndata_guid:" + q_meta.data_guid);
      }
    }

    return re;
  }
}

function NotNeed環境監測(func_guid: string) {
  // TODO: A01 A98 B04 B21 B22 B28 B30 B31 沒有第七大題
  // TODO: B03 沒有第七大題，長得不一樣 但是多一大題
  let no_ch7_func_guids = ["_A01", "_A98", "_B04", "_B21", "_B22", "_B28", "_B29", "_B30", "_B31"];
  if (no_ch7_func_guids.includes(func_guid)) {
    return true;
  } else {
    return false;
  }
}
